<script>
import FeatureBlock from '@/components/FeatureBlock.vue'
export default {
  name: 'RealWorldCare',
  components: {
    FeatureBlock
  },
  data () {
    return {
      isVisible: false,
      patientBackdrop: "/*\n" +
          "* Created with https://www.css-gradient.com\n" +
          "* Gradient link: https://www.css-gradient.com/?c1=21576e&c2=43b6f0&gt=l&gd=dtt\n" +
          "*/\n" +
          "background: #21576E;\n" +
          "background: linear-gradient(0deg, #21576E, #43B6F0);"
    }
  },
  computed: {
    isDesktop () {
      return (this.$mq !== 'mobile')
    }
  },
  methods: {
    visibilityChanged (isVisible) {
      this.isVisible = isVisible;
    }
  }
}
</script>
<template>
  <section class="clinical-arc">
    <div class="">
      <article class="article-body mb-4">
        <header class="mb-4">
          <h2 class="h2-promo has-text-white filter-dark">Real-World Care.<br>
            <span class="platform-text has-text-gray-darkest">One Platform.</span>
          </h2>
        </header>
        <p class="is-size-5 text-semibold has-text-white text-outline-dark">
          Patients progress through therapy along varied clinical paths.
          <br>
          OVB supports the full therapy arc across diverse clinical cases.
        </p>
      </article>
      <div
          class="patient-grid"
          v-observe-visibility="{callback: visibilityChanged,throttle: 300}"
          :class="{'is-visible': isVisible}"
      >
        <feature-block
            :is-mobile="!isDesktop"
            :has-image="true"
            class="patient-block dark-block"
            :image-area-background="patientBackdrop"
            style="--animation-order: 1;"
        >
          <template #image>
            <div class="image-section">
              <b-image
                  class="patient-image"
                  responsive
                  src="/img/patients/Leo@0.5x.webp"
                  webp-fallback=".png"
                  alt="patient image"
                  ratio="250x250"
                  aria-hidden="true"
                  :rounded="false"
              />
            </div>
          </template>
          <template #title>
            <div class="name-block">Liam</div>
          </template>
          <template #content>
            <div class="content-section">
              <div class="classification">Amblyopia &amp; Strabismus</div>
              <div class="target">Binocular Control &rarr; Stability &rarr; Functional Vision</div>
            </div>
          </template>
        </feature-block>
        <feature-block
            :is-mobile="!isDesktop"
            :has-image="true"
            class="patient-block dark-block"
            :image-area-background="patientBackdrop"
            style="--animation-order: 2;"
        >
          <template #image>
            <div class="image-section">
              <b-image
                  class="patient-image"
                  responsive
                  src="/img/patients/Sunny@0.5x.webp"
                  webp-fallback=".png"
                  alt="patient image"
                  ratio="250x250"
                  aria-hidden="true"
                  :rounded="false"
              />
            </div>
          </template>
          <template #title>
            <div class="name-block">Sunny</div>
          </template>
          <template #content>
            <div class="content-section">
              <div class="classification">Brain Injury / Neuro-Rehabilitation</div>
              <div class="target">Focus &rarr; Visual Control &rarr; Functional Application</div>
            </div>
          </template>
        </feature-block>
        <feature-block
            :is-mobile="!isDesktop"
            :has-image="true"
            class="patient-block dark-block"
            style="--animation-order: 3;"
            :image-area-background="patientBackdrop"
        >
          <template #image>
            <div class="image-section">
              <b-image
                  class="patient-image"
                  responsive
                  src="/img/patients/Paisley@0.5x.webp"
                  webp-fallback=".png"
                  alt="patient image"
                  ratio="250x250"
                  aria-hidden="true"
                  :rounded="false"
              />
            </div>
          </template>
          <template #title>
            <div class="name-block">Paisley</div>
          </template>
          <template #content>
            <div class="content-section">
              <div class="classification">Reading &amp; Academic Challenges</div>
              <div class="target">Visual Foundations  &rarr; Decoding &rarr; Fluency</div>
            </div>
          </template>
        </feature-block>
        <feature-block
            :is-mobile="!isDesktop"
            :has-image="true"
            class="patient-block dark-block"
            style="--animation-order: 4;"
            :image-area-background="patientBackdrop"
        >
          <template #image>
            <div class="image-section">
              <b-image
                  class="patient-image"
                  responsive
                  src="/img/patients/Will@0.5x.webp"
                  webp-fallback=".png"
                  alt="patient image"
                  ratio="250x250"
                  aria-hidden="true"
                  :rounded="false"
              />
            </div>
          </template>
          <template #title>
            <div class="name-block">Will</div>
          </template>
          <template #content>
            <div class="content-section">
              <div class="classification">Athlete</div>
              <div class="target">Optimal Performance &rarr; Precision &rarr; Endurance</div>
            </div>
          </template>
        </feature-block>
        <feature-block
            :is-mobile="!isDesktop"
            :has-image="true"
            class="patient-block dark-block"
            style="--animation-order: 5;"
            :image-area-background="patientBackdrop"
            content-area-background="background-color: #2A2B2A;"
        >
          <template #image>
            <div class="image-section">
              <b-image
                  class="patient-image"
                  responsive
                  src="/img/patients/Mason@0.5x.webp"
                  webp-fallback=".png"
                  alt="patient image"
                  ratio="250x250"
                  aria-hidden="true"
                  :rounded="false"
              />
            </div>
          </template>
          <template #title>
            <div class="name-block">Mason</div>
          </template>
          <template #content>
            <div class="content-section">
              <div class="classification">Neurodivergent + Visual-Motor</div>
              <div class="target">Ocular Motor Control &rarr; Sensorimotor Integration &rarr; Stability</div>
            </div>
          </template>
        </feature-block>
      </div>
    </div>
  </section>
</template>
<style scoped lang="scss">
.clinical-arc {
  margin: 0 0 4rem 0;
  @include desktop {
    height: 80vh;
  }
}
.platform-text {
  color: #43B6F0;
  //color: #463B3C;
}
.clinic-grid {
  display:grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
}
.patient-grid-mobile {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1rem;
}
  .patient-grid {
    display: grid;
    grid-template-columns: 1fr;
    @include tablet {
      grid-template-columns: repeat( auto-fill, minmax(16rem, 1fr));
    }
    grid-gap: 1rem;
    &.is-visible {
      .patient-block {
        animation-name: animateIn;
        animation-duration: 900ms;
        animation-delay: calc(var(--animation-order) * 100ms);
        animation-fill-mode: both;
        animation-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);
      }
    }
    .patient-block {
      opacity: 0;
      .image-section {
        padding: 0.5rem 0.5rem 0 0.5rem;
        @include tablet {
          padding: 1rem 1rem 0 1rem;
        }

        .patient-image {
          max-height: 120px;
          max-width: 120px;
          @include tablet {
            max-height: 170px;
            max-width: 170px;
          }
        }
      }
      .name-block {
        font-weight: $font-bold;
        @include desktop {
          text-align: center;
        }
      }
      .content-section {
        font-size: $size-7;
        @include desktop {

        }
        .classification {
          font-weight: $font-semibold;
          margin-bottom: 0.5rem;
          @include desktop {
            text-align: center;
          }
        }
        .target {
          @include desktop {
            text-align: center;
          }
        }
      }
    }
  }
@keyframes animateIn {
  0% {
    opacity: 0;
    transform: translateY(60px);
  }

  100% {
    opacity: 1;
  }
}
</style>
